interface Props {
  messages?: string[];
}

export default function ServerError({ messages }: Props) {
  const text = messages && messages.length > 0 ? messages.join(' ') : 'Unknown Error';
  return (
    <div className="serverError">
      <p>Wystąpił problem z serwerem. Wiadomość: <strong>{text}</strong></p>
    </div>
  );
}
